import React from 'react'
import { Text, View } from 'react-native'
import { FormFieldsModel, ModelAnswerFromProps } from './models/StoreDetailModel'
import { InputPhotoField } from './FieldItems/InputPhotoField'
import { InputCommentField } from './FieldItems/InputCommentField'
import { InputNumberPriceField } from './FieldItems/InputNumberPriceField'
import { SiNoNaField } from './FormItems/SiNoNaItem'

interface FieldsViewProps {
    fields: FormFieldsModel[]
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    closeBottomSheet: (l) => void
    checkComplete: (option?: ModelAnswerFromProps) => void
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
    saveItemSteps?: (option?: ModelAnswerFromProps) => void
    onSubInputMeasure?: (id: string, screenY: number, inputH: number) => void
}

export const FieldsView = ({
    fields,
    form_id,
    schedule_id,
    store_id,
    answerProp,
    closeBottomSheet,
    checkComplete,
    keyboardHiddenState,
    onFocus,
    activeInputId,
    saveItemSteps,
    onSubInputMeasure,
}: FieldsViewProps) => {
    console.log('FieldsView ~ fields:', fields)
    console.log('FieldsView ~ answerProp:', answerProp)

    return (
        <View>
            {fields.map((field, index) => {
                return (
                    <View key={field.label + index}>
                        {/* <Text>{field.type?.title + field.type?.type}</Text> */}
                        {(() => {
                            switch (field.type?.type) {
                                case 4:
                                    return (
                                        <InputPhotoField
                                            item={field}
                                            hasCamera={true}
                                            hasGalery={true}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            saveItemSteps={saveItemSteps}
                                        />
                                    )
                                case 5:
                                    return (
                                        <InputCommentField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            closeBottomSheet={closeBottomSheet}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                            saveItemSteps={saveItemSteps}
                                            onSubInputMeasure={onSubInputMeasure}
                                        />
                                    )
                                case 9:
                                case 15:
                                    return (
                                        <InputNumberPriceField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            closeBottomSheet={closeBottomSheet}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                            isPrice={field.type?.type === 15}
                                            onSubInputMeasure={onSubInputMeasure}
                                        />
                                    )

                                case 32:
                                    return (
                                        <InputPhotoField
                                            item={field}
                                            hasCamera={true}
                                            hasGalery={false}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            saveItemSteps={saveItemSteps}
                                        />
                                    )
                                case 33:
                                    return (
                                        <InputPhotoField
                                            item={field}
                                            hasCamera={false}
                                            hasGalery={true}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            checkComplete={checkComplete}
                                            saveItemSteps={saveItemSteps}
                                        />
                                    )

                                case 7:
                                case 8:
                                case 18:
                                    return (
                                        <SiNoNaField
                                            item={field}
                                            form_id={form_id}
                                            schedule_id={schedule_id}
                                            store_id={store_id}
                                            answerProp={answerProp}
                                            key={field.label + index}
                                            closeBottomSheet={closeBottomSheet}
                                            checkComplete={checkComplete}
                                            keyboardHiddenState={keyboardHiddenState}
                                            onFocus={onFocus}
                                            activeInputId={activeInputId}
                                            saveItemSteps={saveItemSteps}
                                        />
                                    )
                                default:
                                    return <Text key={index}>No se pudo cargar</Text>
                            }
                        })()}
                    </View>
                )
            })}
        </View>
    )
}
